import * as React from 'react';
import Svg, { Path, SvgProps } from 'react-native-svg';

import { designSystem } from '@/styles/styles';

export const EditLineIcon = (props: SvgProps) => (
    <Svg width={16} height={16} {...props} fill="none">
        <Path
            stroke={props.color || designSystem.colors.neutral900}
            strokeLinejoin="round"
            strokeWidth={1.25}
            d="m12.007 7.293-3.3-3.3m-5.423 9.11 3.125-.552c.269-.047.517-.176.71-.37l5.595-5.595a2.334 2.334 0 1 0-3.3-3.3L3.819 8.88a1.333 1.333 0 0 0-.37.712l-.55 3.125a.333.333 0 0 0 .385.386Z"
        />
    </Svg>
);
